import PropTypes from 'prop-types';

const AddMemberPropType = {
  className: PropTypes.string,
};

export default AddMemberPropType;
